import React from "react";
import TranslatedPage from "../../containers/TranslatedPage";
import IconFromPath from "../../containers/TranslatedPage/IconFromPath";
import { I18n } from "react-redux-i18n";

const HowItWorksSection = () => {
  return (
    <section className="gray-bg">
      <div className="main-container">
        <div className="content-wrapper">
          <h1 className="hero-heading how-it-works">
            <TranslatedPage path="home.content_blocks.how_it_works_header.heading" />
          </h1>
          <div className="feature-list large how-it-works">
            <div className="feature-item">
              <div className="icon-wrapper">
                <IconFromPath
                  iconSize="40"
                  className="icon primary-color"
                  path="home.content_blocks.how_it_works_1.icon"
                  custom={true}
                />
                <span className="icon-label">
                  <TranslatedPage path="home.content_blocks.how_it_works_1.heading" />
                </span>
              </div>
              <div className="feature-copy">
                <h2 className="bp3-heading">
                  <TranslatedPage path="home.content_blocks.how_it_works_1.subheading" />
                </h2>
                <TranslatedPage path="home.content_blocks.how_it_works_1.content" />
              </div>
            </div>

            <div className="feature-item">
              <div className="icon-wrapper">
                <IconFromPath
                  iconSize="40"
                  className="icon primary-color"
                  path="home.content_blocks.how_it_works_2.icon"
                  custom={true}
                />
                <span className="icon-label">
                  <TranslatedPage path="home.content_blocks.how_it_works_2.heading" />
                </span>
              </div>
              <div className="feature-copy">
                <h2 className="bp3-heading">
                  <TranslatedPage path="home.content_blocks.how_it_works_2.subheading" />
                </h2>
                <TranslatedPage path="home.content_blocks.how_it_works_2.content" />
              </div>
            </div>

            <div className="feature-item">
              <div className="icon-wrapper">
                <IconFromPath
                  iconSize="40"
                  className="icon primary-color"
                  path="home.content_blocks.how_it_works_3.icon"
                  custom={true}
                />
                <span className="icon-label">
                  <TranslatedPage path="home.content_blocks.how_it_works_3.heading" />
                </span>
              </div>
              <div className="feature-copy">
                <h2 className="bp3-heading">
                  <TranslatedPage path="home.content_blocks.how_it_works_3.subheading" />
                </h2>
                <TranslatedPage path="home.content_blocks.how_it_works_3.content" />
              </div>
            </div>
          </div>
          <br />
          <div className="center-aligner">
            <a href="https://blog.ihopa.com/faq/" target="_blank" rel="noopener noreferrer" className="bp3-button bp3-intent-primary full-width"><strong>{I18n.t("home.ready_to_co_own.faq_button")}</strong></a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
